import {
  fetchApiGeoGetDistrictsTree,
  TApiGeoGetDistrictsTreeResponse,
  IApiGeoGetDistrictsTreeRequest,
} from 'shared/repositories/monolith-cian-realty/api/geo/get-districts-tree';
import { IApplicationContext } from 'shared/types/applicationContext';
import { IGeoDistrict } from 'shared/types/geo';

export const fetchDistrictsTree = async (
  { httpApi, custom: { subdomain } }: IApplicationContext,
  parameters: IApiGeoGetDistrictsTreeRequest,
): Promise<IGeoDistrict[]> => {
  const { response }: TApiGeoGetDistrictsTreeResponse = await fetchApiGeoGetDistrictsTree({
    httpApi,
    parameters,
    config: { subdomain },
  });

  return response;
};
